import { Spinner } from "components/spinner/spinner";
import { COLORS, LINES } from "libs/colors";
import { ProductItemModel } from "libs/models/batch-model";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, ApplicationState } from "store";
import { setProductOperationsProps } from "store/slices/product-operations";
import { formatNumber } from "utils/numbers";
import { removeUnnecessaryZeros } from "utils/shared";
import translate from "utils/translations";
interface RechargeProps {
  validateRecharge: () => void;
  disabled: boolean;
  balance: string;
}
export const RechargeBox = ({
  validateRecharge,
  disabled,
  balance,
}: RechargeProps) => {
  const rechargeRef = useRef<HTMLInputElement>(null);
  const rechargeAmount = useSelector(
    (state: ApplicationState) => state.productoperations.rechargeAmount
  );
  const actionLoading = useSelector(
    (state: ApplicationState) => state.productoperations.actionLoading
  );
  const dispatch = useDispatch<AppDispatch>();
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(
      setProductOperationsProps({
        key: name,
        value: value,
      })
    );
  };
  useEffect(() => {
    rechargeRef.current?.focus();
  }, []);

  return (
    <div className="rounded-2xl ring-1 ring-slate-200 bg-white p-5 mt-3">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          {translate("Charge_Card_Text", "Charge Card TODO")}
        </label>
        <div className="w-full h-1 bg-slate-200 rounded overflow-hidden mb-2" />
        <label className="block text-sm font-medium text-slate-700 mb-1">
          {translate("Amount_Text", "Amount TODO")}
        </label>
        <div className="flex flex-row items-center gap-2 justify-between mb-3">
          <SuggestionAmount amount="100" />
          <SuggestionAmount amount="200" />
          <SuggestionAmount amount="500" />
        </div>
        <input
          type="number"
          inputMode="numeric"
          ref={rechargeRef}
          placeholder={translate("Enter_Amount_Text", "Enter Amount")}
          value={rechargeAmount}
          name="rechargeAmount"
          onInput={removeUnnecessaryZeros}
          onChange={onChange}
          className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-base shadow-inner focus:outline-none focus:ring-4 focus:ring-emerald-200 disabled:opacity-50"
          min={0}
          step={1}
          disabled={disabled}
          aria-describedby="redeem-hint"
        />
        <button
          type="button"
          className="mt-3 h-11 w-full rounded-xl bg-emerald-600 text-white font-semibold shadow hover:bg-emerald-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-200 disabled:opacity-50"
          onClick={() => validateRecharge()}
          disabled={disabled || actionLoading !== null}
          aria-busy={actionLoading === "recharge"}
        >
          {actionLoading === "recharge" ? (
            <Spinner label="Recharging" />
          ) : (
            translate("Recharge_Text", "Recharge TODO")
          )}
        </button>
      </div>
    </div>
  );
};

const SuggestionAmount = ({ amount }: { amount: string }) => {
  const dispatch = useDispatch<AppDispatch>();
  const rechargeAmount = useSelector(
    (state: ApplicationState) => state.productoperations.rechargeAmount
  );
  const selected = amount === rechargeAmount;

  return (
    <div
      className={`w-1/3 py-1 border border-[#518C7D] rounded-md cursor-pointer hover:bg-[#518C7D] hover:text-white transition-colors flex items-center justify-center ${
        selected ? `text-white ${COLORS.PRIMARY}` : "text-[#518C7D] bg-white"
      }`}
      onClick={() =>
        dispatch(
          setProductOperationsProps({
            key: "rechargeAmount",
            value: amount,
          })
        )
      }
    >
      {amount}
    </div>
  );
};
